export const RESET = 'EXCMUSERDATASALESOPPORTUNITY_LIST_RESET'
export const SET_ITEMS = 'EXCMUSERDATASALESOPPORTUNITY_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMUSERDATASALESOPPORTUNITY_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMUSERDATASALESOPPORTUNITY_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMUSERDATASALESOPPORTUNITY_LIST_TOGGLE_LOADING'
